import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const freeSlackCol = (gantt, t) => {
  const name = 'freeSlack';
  const isVisible = isColumnVisibleByDefault(name);
  const navigatorLang = navigator.language || navigator.userLanguage;

  return {
    name,
    label: t('gantt.columns.freeSlack', 'Holgura Libre'),
    align: 'center',
    resize: true,
    width: '*',
    data_type: 'number',
    template: function (activity) {
      const state = gantt.getState().drag_mode;
      let isOdd = false;
      if (gantt.oddColsConfig) {
        isOdd = gantt.oddColsConfig.freeSlack;
      }

      if (gantt.isSummaryTask(activity)) {
        return (
          '<div class="' + (isOdd ? 'odd-col' : 'non-odd-col') + '"> </div>'
        );
      }
      const hasChild = gantt.hasChild(activity.id);

      return navigatorLang.includes('en')
        ? '<div class="' +
            (isOdd ? 'odd-col' : 'non-odd-col') +
            '" style="' +
            (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
            '">' +
            activity.freeSlack +
            '</div>'
        : '<div class="' +
            (isOdd ? 'odd-col' : 'non-odd-col') +
            '" style="' +
            (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
            '">' +
            activity.freeSlack +
            '</div>';
    }
,
    hide: !isVisible,
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → N', 'N → 1'],
    filterable: true,
  };
};

export default freeSlackCol; 